import axios from "./axios";

const base = "/crew";

export const crewApi = {
  roster: (params) => axios.get(`${base}/roster`, { params }),
  shifts: (params) => axios.get(`${base}/shifts`, { params }),
  createShift: (shift) => axios.post(`${base}/shifts`, { shift }),
  updateShift: (id, shift, reason) => axios.patch(`${base}/shifts/${id}`, { shift, reason }),
  deleteShift: (id) => axios.delete(`${base}/shifts/${id}`),
  publishShift: (id) => axios.post(`${base}/shifts/${id}/publish`),
  cancelShift: (id, reason) => axios.post(`${base}/shifts/${id}/cancel`, { reason }),

  assignments: (params) => axios.get(`${base}/shift_assignments`, { params }),
  createAssignment: (shift_assignment) => axios.post(`${base}/shift_assignments`, { shift_assignment }),
  updateAssignment: (id, shift_assignment) => axios.patch(`${base}/shift_assignments/${id}`, { shift_assignment }),
  acceptAssignment: (id) => axios.post(`${base}/shift_assignments/${id}/accept`),
  declineAssignment: (id) => axios.post(`${base}/shift_assignments/${id}/decline`),

  availabilities: (params) => axios.get(`${base}/availabilities`, { params }),
  createAvailability: (availability) => axios.post(`${base}/availabilities`, { availability }),
  updateAvailability: (id, availability) => axios.patch(`${base}/availabilities/${id}`, { availability }),
  deleteAvailability: (id) => axios.delete(`${base}/availabilities/${id}`),

  timePunches: (params) => axios.get(`${base}/time_punches`, { params }),
  openPunches: () => axios.get(`${base}/time_punches/open`),
  clockIn: (time_punch) => axios.post(`${base}/time_punches`, { time_punch }),
  clockOut: (id, time_punch) => axios.patch(`${base}/time_punches/${id}`, { time_punch }),

  complianceAlerts: (params) => axios.get(`${base}/compliance_alerts`, { params }),
  payrollPreview: (params) => axios.get(`${base}/payroll_preview`, { params }),
  shiftChecklists: (params) => axios.get(`${base}/shift_checklists`, { params }),
  updateShiftChecklist: (id, shift_checklist) => axios.patch(`${base}/shift_checklists/${id}`, { shift_checklist }),
  verifyKioskPin: (payload) => axios.post(`${base}/kiosk_verify`, payload),
  setKioskPin: (employeeId, payload) => axios.patch(`${base}/employees/${employeeId}/kiosk_pin`, payload),
  setKioskPinByUser: (payload) => axios.patch(`${base}/kiosk_pin`, payload),
  seedChecklistTemplates: () => axios.post(`${base}/checklist_templates/seed`),
};

export const formatLocalDateTimeInput = (value) => {
  if (!value) return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const todayDateInput = () => new Date().toISOString().substring(0, 10);
